import React from 'react';
import { graphql } from 'gatsby';
import { brandColours } from '../styles';
import Layout from '../components/Layout';
import SubBanner from '../components/SubBanner';
import Breadcrumbs from '../components/Breadcrumbs';
import EventVenueDetail from '../components/EventVenueDetail';
import FeaturedProducts from '../components/FeaturedProducts';
import { orderFeaturedProducts, addCtasToEvents } from '../utils';

const EventVenuePageTemplate = ({
  data: {
    datoCmsEventVenue: {
      seoMetaTags,
      name,
      bannerImage,
      content,
      address,
      phoneNumber,
      website,
    },
    datoCmsEventVenueSitewide: { ctaHeading, ctaLink },
    allDatoCmsEvent: { nodes },
    datoCmsEventsArchive: { bannerImage: fallbackBannerImage, listingCtas },
    allShopifyProduct: { nodes: featuredProducts },
  },
  pageContext: { featuredProducts: featuredProductsOrder },
}) => {
  const items = addCtasToEvents(listingCtas, nodes);

  return (
    <Layout seo={seoMetaTags}>
      <main>
        <Breadcrumbs
          currentPageTitle={name}
          items={[
            {
              text: 'Exhibition Calendar',
              urlPath: '/exhibition-calendar/',
            },
          ]}
        />
        <SubBanner
          heading={name}
          backgroundImage={bannerImage || fallbackBannerImage}
          backgroundColour={{ hex: brandColours.primary }}
        />
        <EventVenueDetail
          content={content}
          items={items}
          cta={{ heading: ctaHeading, link: ctaLink }}
          name={name}
          address={address}
          phoneNumber={phoneNumber}
          website={website}
        />
        <FeaturedProducts
          heading="Popular products for exhibitions at this venue"
          items={orderFeaturedProducts(featuredProducts, featuredProductsOrder)}
          alt={true}
        />
      </main>
    </Layout>
  );
};

export const EventVenuePageTemplateTemplateQuery = graphql`
  query EventVenuePageTemplateTemplateQuery(
    $id: String!
    $todaysDate: Date!
    $featuredProducts: [String!]
  ) {
    datoCmsEventVenue(id: { eq: $id }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      name
      bannerImage {
        gatsbyImageData(
          width: 2000
          height: 430
          layout: FULL_WIDTH
          imgixParams: { w: "2000", h: "430" }
        )
        alt
      }
      content {
        value
        links {
          id: originalId
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
      address
      phoneNumber
      website
    }
    datoCmsEventVenueSitewide {
      ctaHeading
      ctaLink {
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    allDatoCmsEvent(
      filter: { startDate: { gte: $todaysDate }, venue: { id: { eq: $id } } }
      sort: { startDate: ASC }
    ) {
      nodes {
        id
        ...EventCardFragment
      }
    }
    datoCmsEventsArchive {
      bannerImage {
        gatsbyImageData(
          width: 2000
          height: 430
          layout: FULL_WIDTH
          imgixParams: { w: "2000", h: "430" }
        )
        alt
      }
      listingCtas {
        startDate: date(formatString: "DD MMM YYYY")
        monthYear: date(formatString: "MMMM YYYY")
        originalDate: date
        listingCta {
          ...ListingCtaCardFragment
        }
      }
    }
    allShopifyProduct(filter: { handle: { in: $featuredProducts } }) {
      nodes {
        ...ProductCardFragment
      }
    }
  }
`;

export default EventVenuePageTemplate;
